/**
 * Utility for handling color eyeDropper functionality
 */
import globalLogger from '../../logger/logger';

const logger = globalLogger.createChannel('utils.eyedropper');

// Types for the EyeDropper API as it is not yet widely supported
declare global {
    interface Window {
        EyeDropper?: {
            new (): EyeDropper;
        };
    }

    interface EyeDropper {
        open(): Promise<{ sRGBHex: string }>;
    }
}

/**
 * Opens the browser's native color eyeDropper tool if supported.
 */
export const openColorEyeDropper = async (): Promise<string | null> => {
    // Check if the browser supports the EyeDropper API
    if (!window.EyeDropper) {
        logger.warn('EyeDropper API is not supported in this browser');
        return null;
    }

    try {
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open();
        return result.sRGBHex;
    } catch (error) {
        // User cancelled or another error occurred
        return null;
    }
};

/**
 * Checks if the browser supports the EyeDropper API.
 */
export const isEyeDropperSupported = (): boolean => {
    return typeof window !== 'undefined' && 'EyeDropper' in window;
};
